import { useAuthStore } from "@/store/AuthStore.ts";
import { useUserInfoStore } from "@/store/userInfo.ts";
import { useMutationCache, useQueryCache } from "@pinia/colada";

export function useLogout() {
  const authStore = useAuthStore();
  const userInfoStore = useUserInfoStore();
  const queryCache = useQueryCache();
  const mutationCache = useMutationCache();

  function logout() {
    authStore.logout();
    userInfoStore.clearCache();
    queryCache.cancelQueries();
    queryCache.getEntries().forEach((entry) => queryCache.remove(entry));
    mutationCache.getEntries().forEach((entry) => mutationCache.remove(entry));
  }

  return { logout };
}
